import { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import { Loader } from "../../common/components/core";
import CreateNewProfileForm, {
    CreateNewProfileFormValues,
} from "./components/CreateNewProfileForm";
import useConfirmCreateProfileHandler from "./hooks/useConfirmCreateProfileHandler";
import { PageTitle } from "../../types/pageTitle";

const CreateNewProfileView = (): JSX.Element => {
    document.title = PageTitle.CreateNewProfileView;
    const [isSubmitting] = useState(false);
    const { handler: createEntity } = useConfirmCreateProfileHandler();
    const submit = async (values: CreateNewProfileFormValues) => {
        createEntity(values);
    };
    return (
        <PureCreateNewProfileView isLoading={isSubmitting} onSubmit={submit} />
    );
};

type PureCreateNewProfileViewProps = {
    isLoading: boolean;
    onSubmit: (values: CreateNewProfileFormValues) => void;
};

export const PureCreateNewProfileView = ({
    isLoading,
    onSubmit,
}: PureCreateNewProfileViewProps): JSX.Element => {
    const history = useHistory();

    return (
        <Loader
            overlay={true}
            isLoading={isLoading}
            bgClassName="bg-body"
        >
            <Breadcrumb className="mb-5">
                <Breadcrumb.Item linkAs="span">
                    <NavLink to="/profile-management">
                        Profile Management
                    </NavLink>
                </Breadcrumb.Item>
                <Breadcrumb.Item active className="fw-bold">
                    Create New Profile
                </Breadcrumb.Item>
            </Breadcrumb>
            <CreateNewProfileForm
                onCancel={() => history.push("/profile-management")}
                onSubmit={onSubmit}
            />
        </Loader>
    );
};

export default CreateNewProfileView;
